import React, { useState , useCallback } from 'react';
import { Row, Col, Select, Input, Button, Modal } from 'antd';
import { EnvironmentOutlined, CloseOutlined , CloseCircleFilled} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import {EditIcon} from '../../images';
import UnitType from '../../helpers/UnitType';
import { useLoading } from '../../hooks/order';
import { getSegregatedAddress, getAggregatedAddress } from '../../common/common';

// eslint-disable-next-line no-unused-vars
const VerifyAddressModal = (props) => {
  const { t } = useTranslation();
  const [showSecondAddressLine, setShowSecondAddressLine] = useState(false)
  const [unitAddress, setUnitAddress] = useState({
    unitType: '',
    unitNumber: '',
    secondUnitType: '',
    secondUnitNumber: '',
  });
  const { unitType, unitNumber, secondUnitType, secondUnitNumber } = unitAddress;
  const address2 = `${unitType} ${unitNumber} ${secondUnitType} ${secondUnitNumber}`;
  const { address1, city, state, zip } = getSegregatedAddress(props?.searchAddress);
  const newManualAddress = {
    address1,
    address2: address2?.trimEnd(),
    city,
    zip,
    state,
  };
  const manualAddressValue =(newManualAddress?.address2?.length &&
     getAggregatedAddress(newManualAddress)) || '';

  const { loading } = useLoading();
  const handleThirdAddress = () => {
    setShowSecondAddressLine(!showSecondAddressLine);
    setUnitAddress({...unitAddress,secondUnitType: '',secondUnitNumber: '' })
  }

  const handleInputChange = useCallback(
    (e) => {
      const { value, name } = e.target;
      setUnitAddress({ ...unitAddress, [name]: value?.trimStart() });
    },
    [unitAddress],
  );

  const handleSubmit = () => {
    // eslint-disable-next-line no-unused-expressions
    props?.handleSubmit(manualAddressValue, false);
  }

  const disabledSubmit = useCallback(() => {
    if (unitNumber.length <= 0 || unitType.length <= 0) {
      return true;
    }
    if (showSecondAddressLine) {
      if (secondUnitNumber.length <= 0 || secondUnitType.length <= 0) {
        return true;
      }
    }
    return false;
  }, [showSecondAddressLine, unitAddress]);

  return (
    <>
      <Modal
        title={
          <div className="title-wrap">
            <CloseOutlined className="close-icon"  onClick={props.handleClose} />
            <div>{t('verifyAddress.modalTitle')}</div>
            <div className="address-header-details" style={{ }}>
              <EnvironmentOutlined className="location-icon" />
              <p className="address-text">{props?.searchAddress}</p>
              <img src={EditIcon} className="edit-address-icon" onClick={props.handleEdit} alt="Edit" />
            </div>
          </div>
        }
        visible={props.isModalOpen}
        footer={null}
        closable={false}
        onCancel={props.handleClose }
        onClose={props.handleClose}
        width={820}
        className="modalRoot"
      >
        <div className="row-conatiner">
          <h4>{t('verifyAddress.multipleUnits')}</h4>
          <Row gutter={[10, 10]} className="row-items">
            <Col span={12} id="select-unit" >
              <label className="address-label">{t('verifyAddress.selectUnitType')}</label>
              <br />
              <Select
                allowClear
                placeholder={t('verifyAddress.unitPlaceholder')}
                value={unitType ? unitType : undefined}
                onSelect={(value) => {
                  setUnitAddress({ ...unitAddress, unitType: value });
                }}
              >
                {UnitType?.map(({ code }) => (
                  <Select.Option key={code} value={code}>
                    {code} - {t(`verifyAddress.unitType${code}`)}
                  </Select.Option>
                ))}
              </Select>
            </Col>
            <Col span={12} className="select-unit-input">
              <label className="address-label">{t('verifyAddress.enterUnitNumber')}</label>
              <br />
              <Input
                placeholder={t('verifyAddress.unitNumberPlaceholder')}
                name="unitNumber"
                maxLength={6}
                onChange={handleInputChange}
                value={unitNumber}
              />
            </Col>
            {showSecondAddressLine ? (
              <><Col span={12} id="select-unit">
                <label className="address-label">{t('verifyAddress.selectSecondUnitType')}</label>
                <br />
                <Select
                  allowClear
                  placeholder={t('verifyAddress.unitPlaceholder')}
                  value={secondUnitType ? secondUnitType : undefined}
                  onSelect={(value) => {
                    setUnitAddress({ ...unitAddress, secondUnitType: value });
                  }}
                >
                  {UnitType?.map(({ code, name }) => (
                    <Select.Option key={code} value={code}>
                      {code} - {name}
                    </Select.Option>
                  ))}
                </Select>
              </Col>
              <Col span={12} className="select-unit-input">
                <label className="address-label">{t('verifyAddress.enterUnitNumber')}</label>
                <br />
                <Input
                  placeholder={t('verifyAddress.unitNumberPlaceholder')}
                  name="secondUnitNumber"
                  maxLength={6}
                  onChange={handleInputChange}
                  value={secondUnitNumber}
                />
              </Col>
              <Col style={{ marginTop:'27px'}}>
                <a onClick={handleThirdAddress}>
                  <CloseCircleFilled className="remove-second-unit"/>
                </a>
              </Col>
              </>) :
              <Col style={{ marginRight: '100px', padding : '0 5px'}}>
                <a onClick={handleThirdAddress} style={{color: '#007cba', fontWeight: 'bold'}}>
                  {t('verifyAddress.addAnother')}
                </a>
              </Col>}
          </Row>
        </div>
        <div className="modal-button-container">
          <Button
            type="cancel"
            className="modal-cancel-button"
            disabled={loading}
            onClick={props.handleClose}>
            {t('verifyAddress.cancel')}
          </Button>
          <Button
            type="primary"
            className="modal-submit-button"
            loading={loading}
            disabled={disabledSubmit()}
            onClick={() => handleSubmit()}>
            {t('verifyAddress.submit')}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default VerifyAddressModal;
